/* collect-rangers 埋點方法封裝 */

import { isClient } from '@gateio/core-utils'

interface StringObject {
  [key: string]: any
}

interface StaticTrackerReturnsType {
  'data-click-event'?: string
  'data-hover-event'?: string
  'data-collect-params': string
}

type EventType = 'hover' | 'click'

const staticEventTracker =
  (type: EventType = 'click') =>
  (eventName: string, params: StringObject = {}): StaticTrackerReturnsType | Record<string, never> => {
    if (!eventName) return {}
    return {
      [`data-${type}-event`]: eventName,
      'data-collect-params': JSON.stringify(params),
    }
  }

export const clickEventTracker = staticEventTracker('click')
export const hoverEventTracker = staticEventTracker('hover')

export const eventTracker = (eventName: string, params: StringObject = {}): void => {
  if (!isClient() || !window?.collectEvent || !eventName) return
  window.collectEvent('beconEvent', eventName, params)
}

export const eventNewTracker = (eventName: string, params: StringObject = {}): void => {
  if (!isClient() || !window?.collectEvent || !eventName) return
  window.collectEvent('beconEvent', eventName, params)
}
